import { OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Component, Input } from '@angular/core';
import { CHECKED_STATUS, SearchService } from '../../../services/search/search.service';
import { StorageService } from '../../../services/storage/storage.service';
import { TargetGroups } from '../../../core/interfaces/search.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-search-resources',
  templateUrl: './search-resources.component.html',
  styleUrls: ['./search-resources.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchResourcesComponent implements OnInit, OnDestroy {
  @Input() overlay: boolean;

  private _destroyed$ = new Subject<void>();

  PARTIAL_CHECKED = CHECKED_STATUS.PARTIAL;
  resources: TargetGroups[];
  showCollapseAll: boolean;

  constructor(
    private _searchService: SearchService,
    private _storageService: StorageService,
  ) {}

  ngOnInit() {
    this._searchService
      .getQuickSearchResourcesBS()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((quickSearchResources) => {
        if (!quickSearchResources) {
          return;
        }

        this.resources = quickSearchResources;

        if (this.resources?.length) {
          this.showCollapseAll = !this.resources.some((r) => r.isCollapse);
        }
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  openUrl(url = ''): void {
    if (url?.includes('useracct.asp?') || url?.includes('MyStatus.aspx')) {
      url = this.includeSessId(url);
      this.openLink(url);
    } else {
      this.openLink(url);
    }
  }

  private includeSessId(url = ''): string {
    if (url?.includes('myses=&')) {
      const userdata = this._storageService.getItem('userData');
      const sessionId = userdata?.sessionId;
      if (sessionId) {
        url = url.replace('myses=&', `myses=${sessionId}&`);
      }
    }
    return url;
  }

  openLink(url) {
    if (url) {
      window.open(url, '_blank', 'location=yes,height=650,width=650,scrollbars=yes,status=yes');
    }
  }

  resetAll() {
    this.resources = this._searchService.getSearchResources();
    this.emitResourceSelection();
  }

  checkGroup(event, targets) {
    targets.forEach((t) => (t.isDefault = event.target.checked));
    SearchService.setCheckStatus(this.resources);
    this.emitResourceSelection();
  }

  checkResource(event, resource): void {
    resource.isDefault = event.target.checked;
    SearchService.toggleResourcesByLibraryDBPoolKey(this.resources, resource);
    this.emitResourceSelection();
  }

  checkAll(checked: boolean) {
    this.resources.forEach((r) => r.searchTargets.forEach((s) => (s.isDefault = checked)));
    SearchService.setCheckStatus(this.resources);
    this.emitResourceSelection();
  }

  toggleGroup(item: TargetGroups) {
    item.isCollapse = !item.isCollapse;

    if (item.isCollapse) {
      const allCollapse = !this.resources.some((r) => !r.isCollapse);
      if (allCollapse) {
        this.showCollapseAll = false;
      }
    } else {
      const allExpanded = !this.resources.some((r) => r.isCollapse);
      if (allExpanded) {
        this.showCollapseAll = true;
      }
    }
  }

  toggleExpandCollapse() {
    this.resources.map((r) => (r.isCollapse = this.showCollapseAll));
    this.showCollapseAll = !this.showCollapseAll;
  }

  private emitResourceSelection() {
    this._searchService.setQuickSearchResourcesBS(this.resources);
  }
}
